import { render } from "./CaseViewerPanel.vue?vue&type=template&id=a6b8850e&scoped=true"
import script from "./CaseViewerPanel.vue?vue&type=script&lang=js"
export * from "./CaseViewerPanel.vue?vue&type=script&lang=js"

import "./CaseViewerPanel.vue?vue&type=style&index=0&id=a6b8850e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6b8850e"]])

export default __exports__